import React, { useEffect } from "react";
import { useState } from "react";
import { Row, Col, Card, Table, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import Loader from "../../../common/Loader";
import NoData from "../../../common/NoData";
import Pagination from "../../../common/Pagination/Pagination";
import { Translate } from "../../../Enums/Tranlate";
import CardItem from "./CardItem";
import BookingRequestsService from "../../../../services/BookingRequestsService";

const BookingRequests = () => {
	const [data, setData] = useState([]);
	const [hasData, setHasData] = useState(null);
	const [loading, setLoading] = useState(false);
	const [shouldUpdate, setShouldUpdate] = useState(false);
	const lang = useSelector((state) => state.auth?.lang);
	const bookingRequestsService = new BookingRequestsService();
	const Auth = useSelector((state) => state.auth?.auth);
	const isExist = (data) => Auth?.roles?.includes(data);
	const search = useSelector((state) => state.auth.search);
	const [params, setParams] = useState({});
	const [paramsData, setParamsData] = useState({
		date: "",
		time: "",
	});

	function convertTo12Hour(time) {
		let [hours, minutes] = time.split(":").map(Number);
		const ampm = hours >= 12 ? "PM" : "AM";
		hours = hours % 12 || 12; // converts 0 -> 12, 13 -> 1, etc.
		return `${hours.toString().padStart(2, "0")}:${minutes
			.toString()
			.padStart(2, "0")} ${ampm}`;
	}

	const applyFilter = () => {
		let paramsUpdate = {};
		if (!!paramsData?.date) paramsUpdate["date"] = paramsData?.date;
		if (!!paramsData?.time) {
			paramsUpdate["time"] = convertTo12Hour(paramsData?.time);
		}
		setParams(paramsUpdate);
		setShouldUpdate((prev) => !prev);
	};

	return (
		<div className="department">
			<div className="mb-4">
				<div className="search-card d-flex justify-content-between align-items-center">
					<div>
						<span
							style={{
								fontWeight: "600",
								textTransform: "capitalize",
								color: "#000",
							}}>
							{Translate[lang].booking_requests}
						</span>
					</div>
				</div>
			</div>
			<div class="accordion " id="accordionExample">
				<div class="accordion-item border-shadow p-0">
					<h2 class="accordion-header" id="headingOne">
						<button
							class="accordion-button fw-bold"
							type="button"
							style={{
								background: "none",
								boxShadow: "none",
								color: "#000",
							}}
							data-bs-toggle="collapse"
							data-bs-target="#collapseOne"
							aria-expanded="true"
							aria-controls="collapseOne">
							{Translate[lang].filter}
						</button>
					</h2>
					<div
						id="collapseOne"
						class="accordion-collapse collapse show"
						aria-labelledby="headingOne"
						data-bs-parent="#accordionExample">
						<div className="row w-100 m-auto pb-3">
							<div className="col-md-3 col-6">
								<label className="d-block">{Translate[lang].date}</label>
								<input
									type="date"
									name={"date"}
									value={paramsData?.date}
									placeholder={Translate[lang].date}
									style={{
										height: "43px",
										padding: "0 10px",
										borderRadius: "10px",
										border: "1px solid hsl(0, 0%, 80%)",
										width: "100%",
									}}
									onChange={(e) =>
										setParamsData((prev) => ({
											...prev,
											date: e.target?.value,
										}))
									}
								/>
							</div>
							<div className="col-md-3 col-6">
								<label className="d-block">{Translate[lang].time}</label>
								<input
									type="time"
									name={"time"}
									value={paramsData?.time}
									placeholder={Translate[lang].time}
									style={{
										height: "43px",
										padding: "0 10px",
										borderRadius: "10px",
										border: "1px solid hsl(0, 0%, 80%)",
										width: "100%",
									}}
									onChange={(e) =>
										setParamsData((prev) => ({
											...prev,
											time: e.target?.value,
										}))
									}
								/>
							</div>
							<div className={"col-md-12 col-12 mt-3"}>
								<div className="d-flex w-50 h-100 gap-8 align-items-end">
									{(!!paramsData?.date || !!paramsData?.time) && (
										<Button
											variant="outline-primary"
											className="w-100"
											onClick={applyFilter}>
											{Translate[lang].apply_filter}
										</Button>
									)}
									{(!!paramsData?.date || !!paramsData?.time) && (
										<Button
											variant="outline-danger"
											className="w-100"
											onClick={() => {
												setParamsData((prev) => ({
													...prev,
													date: "",
													time: "",
												}));
												setShouldUpdate((prev) => !prev);
											}}>
											{Translate[lang].clear_filter}
										</Button>
									)}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<Row className="mt-4">
				<Col lg={12}>
					<Card>
						<div
							className={`${hasData === 0 ? "text-center" : "table-style"} `}>
							{loading && (
								<div style={{ height: "400px" }}>
									<Loader />
								</div>
							)}

							{hasData === 1 && !loading && (
								<Table responsive>
									<thead>
										<tr className="text-center">
											<th>
												<strong>ID</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.court}</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.date}</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.time}</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.user_name}</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.phone}</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.booking}</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.action}</strong>
											</th>
										</tr>
									</thead>

									<tbody className="table-body">
										{data?.map((item, index) => {
											return (
												<CardItem
													index={index}
													setShouldUpdate={setShouldUpdate}
													key={index}
													item={item}
												/>
											);
										})}
									</tbody>
								</Table>
							)}
							{hasData === 0 && <NoData />}
							<Pagination
								setData={setData}
								service={bookingRequestsService}
								shouldUpdate={shouldUpdate}
								setHasData={setHasData}
								setLoading={setLoading}
								search={search}
								param={params}
							/>
						</div>
					</Card>
				</Col>
			</Row>
		</div>
	);
};

export default BookingRequests;
